import Button from "../button";
import EStatus from "../../enums/status";
import IEnvironmentStatus from "../../interfaces/environment-status";
import React, {Dispatch, SetStateAction} from "react";
import { BiRefresh } from "react-icons/bi";
import {
  Card,
  CardsWrapper,
  CardTitle,
  CardValue,
  Container,
  Title,
  TitleWrapper,
} from "./styles";
import EStatusColors from "../../enums/status-colors";
import RangedDatePicker from "../date-picker";

interface IProps {
  environmentStatus: IEnvironmentStatus[];
  refreshAll(): void | any;
  loading: boolean;
  setInitialDate : Dispatch<SetStateAction<Date | null>>;
  initialDate: Date | null;
  setFinalDate : Dispatch<SetStateAction<Date | null>>;
  finalDate: Date | null;
}

const GeneralStatus = (props : IProps) => {
  function getStatusBackgroundColor(status: EStatus): string {
    switch (status) {
      case EStatus.SUCESSO:
        return EStatusColors.SUCESSO;
      case EStatus.PROCESSANDO:
        return EStatusColors.PROCESSANDO;
      case EStatus.ERRO:
        return EStatusColors.ERRO;
      case EStatus.BLOQUEADA:
        return EStatusColors.BLOQUEADA;
      case EStatus.ALERTA:
        return EStatusColors.ALERTA;
      case EStatus.PENDENTE:
        return EStatusColors.PENDENTE;
    }
  }

  function getErrorSum(): number {
    return props.environmentStatus.reduce(
      (result, current) => result + current.erro,
      0
    );
  }
  function getAlertSum(): number {
    return props.environmentStatus.reduce(
      (result, current) => result + current.alerta,
      0
    );
  }
  function getBlockSum(): number {
    return props.environmentStatus.reduce(
      (result, current) => result + current.bloqueada,
      0
    );
  }
  function getProcessingSum(): number {
    return props.environmentStatus.reduce(
      (result, current) => result + current.processando,
      0
    );
  }
  function getPendingSum(): number {
    return props.environmentStatus.reduce(
      (result, current) => result + current.pendente,
      0
    );
  }

  return (
    <Container>
      <TitleWrapper>
        <Title>Total</Title>
        <RangedDatePicker finalDate={props.finalDate}
                          initialDate={props.initialDate}
                          setFinalDate={props.setFinalDate}
                          setInitialDate={props.setInitialDate}
                          onClick={props.refreshAll}/>
        <Button size={38} onClick={props.refreshAll} disabled={props.loading}>
          <BiRefresh size={28} color="#000000de" />
        </Button>
      </TitleWrapper>
      <CardsWrapper>
        <Card
          bgColor={
            getErrorSum() > 0
              ? getStatusBackgroundColor(EStatus.ERRO)
              : getStatusBackgroundColor(EStatus.SUCESSO)
          }
        >
          <CardTitle>Erro</CardTitle>
          <CardValue>{getErrorSum()}</CardValue>
        </Card>
        <Card
          bgColor={
            getAlertSum() > 0
              ? getStatusBackgroundColor(EStatus.ALERTA)
              : getStatusBackgroundColor(EStatus.SUCESSO)
          }
        >
          <CardTitle>Alerta</CardTitle>
          <CardValue>{getAlertSum()}</CardValue>
        </Card>
        <Card
          bgColor={
            getBlockSum() > 0
              ? getStatusBackgroundColor(EStatus.BLOQUEADA)
              : getStatusBackgroundColor(EStatus.SUCESSO)
          }
        >
          <CardTitle>Bloqueada</CardTitle>
          <CardValue>{getBlockSum()}</CardValue>
        </Card>
        <Card
          bgColor={
            getProcessingSum() > 0
              ? getStatusBackgroundColor(EStatus.PROCESSANDO)
              : getStatusBackgroundColor(EStatus.SUCESSO)
          }
        >
          <CardTitle>Processando</CardTitle>
          <CardValue>{getProcessingSum()}</CardValue>
        </Card>
        <Card
          bgColor={
            getPendingSum() > 0
              ? getStatusBackgroundColor(EStatus.PENDENTE)
              : getStatusBackgroundColor(EStatus.SUCESSO)
          }
        >
          <CardTitle>Pendente</CardTitle>
          <CardValue>{getPendingSum()}</CardValue>
        </Card>
      </CardsWrapper>
    </Container>
  );
};

export default GeneralStatus;
